import { mapState, mapMutations } from "vuex";

export default {
  name: "barra",
  data() {
    return { 
      mensaje_general: ''
    };
  },

  created: function () {
    this.refresh_ss();
 
  },
  
  methods: {
 

    refresh_ss() {
      this.$http
        .post(
          "SERVER/scd/dashboard/",
          {
            a: "br1"
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status == 1) { 
            this.mensaje_general = response.data.mensaje_general;
 
          }
        });
    },
 
  }
};



// WEBPACK FOOTER //
// ./src/components/general/msjGeneral/barra.js